import { EducationalPathVersionDTO } from '../../dto/educational-path/educational-path-version.dto';
import { EducationalPathVersionRequirementDTO } from '../../dto/educational-path/educational-path-version-requirement.dto';
import { EducationalPathVersionMaintenanceDTO } from '../../dto/educational-path/educational-path-version-maintenance.dto';
import { EducationalPathVersionRequirement } from './EducationalPathVersionRequirement.model';
import { EducationalPathVersionMaintenance } from './EducationalPathVersionMaintenance.model';

export class EducationalPathVersion {
    constructor(
        public version_id: number,
        public path_id: number,
        public organizations_id: number,
        public name: string,
        public required_maintenance_minutes: number,
        public maintenance_minutes_required: number,
        public maintenance_minutes_completed: number,
        public recurrence_value: number,
        public recurrence_unit: string,
        public recurrence_window_start: string,
        public recurrence_window_end: string,
        public created_at: string,
        public updated_at: string,
        public requirements: EducationalPathVersionRequirement[] = [],
        public maintenance: EducationalPathVersionMaintenance[] = []
    ) {}

    static fromDTO(dto: EducationalPathVersionDTO): EducationalPathVersion {
        const version = new EducationalPathVersion(
            dto.version_id,
            dto.path_id,
            dto.organizations_id,
            dto.name,
            dto.required_maintenance_minutes,
            dto.maintenance_minutes_required,
            dto.maintenance_minutes_completed || 0,
            dto.recurrence_value || 0,
            dto.recurrence_unit || '',
            dto.recurrence_window_start || '',
            dto.recurrence_window_end || '',
            dto.created_at || '',
            dto.updated_at || ''
        );

        if (dto.requirements) {
            version.requirements = dto.requirements.map(r => EducationalPathVersionRequirement.fromDTO(r));
        }

        if (dto.maintenance) {
            version.maintenance = dto.maintenance.map(m => EducationalPathVersionMaintenance.fromDTO(m));
        }

        return version;
    }

    toDTO(): EducationalPathVersionDTO {
        return {
            version_id: this.version_id,
            path_id: this.path_id,
            organizations_id: this.organizations_id,
            name: this.name,
            required_maintenance_minutes: this.required_maintenance_minutes,
            maintenance_minutes_required: this.maintenance_minutes_required,
            maintenance_minutes_completed: this.maintenance_minutes_completed,
            recurrence_value: this.recurrence_value,
            recurrence_unit: this.recurrence_unit,
            recurrence_window_start: this.recurrence_window_start,
            recurrence_window_end: this.recurrence_window_end,
            created_at: this.created_at,
            updated_at: this.updated_at,
            requirements: this.requirements.map(r => r.toDTO()),
            maintenance: this.maintenance.map(m => m.toDTO())
        };
    }
} 